import { useSetupStore } from '../../store';
import { useNotify } from '@/hooks';
import { assertNotEmpty } from '@morph-mapper/utils';
import { useStore } from '@/store';
import { t } from 'i18next';

export const useDomainSelect = () => {
  /* Context state */
  const [step, setCurrentStep, domain, setDomain] = useSetupStore((s) => [
    s.currentStep,
    s.setCurrentStep,
    s.domain,
    s.setDomain,
  ]);
  const [domains] = useStore(({ config: c }) => [c.domainAccess]);

  /* Hooks */
  const { warn } = useNotify();

  /**
   * Handlers
   */
  // We auto select the domain if there is only one domain.
  const skipIfOneDomain = () => {
    assertNotEmpty(domains, 'No domains available for the current operator.');

    if (domains.length > 1) return;

    setCurrentStep(step + 1);
    setDomain(domains[0]);
  };

  // Ensure domain is set when the user clicks the next button.
  const progressSetup = () => {
    if (domains.length === 1) {
      skipIfOneDomain();
      return;
    }

    if (domain === undefined) {
      warn(t('message.warning.selectDomain'));

      return;
    }

    setCurrentStep(step + 1);
  };

  return { progressSetup };
};
